import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "title-big t-blue uppercase text-center mb-5" }
const _hoisted_2 = { class: "d-flex j-content-start a-i-center" }
const _hoisted_3 = { class: "search-input d-flex a-i-center j-content-center" }
const _hoisted_4 = { class: "search-input d-flex a-i-center j-content-start ml-1" }
const _hoisted_5 = { class: "mt-2 wrapper-cart" }
const _hoisted_6 = { class: "cart-result-wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "text-motserrat-16-bold pl-2 pr-2 pt-2 pb-2 mt-2"
}
const _hoisted_8 = { class: "cart-result-wrapper w-100 d-flex j-content-center a-i-center direction-column" }
const _hoisted_9 = { class: "d-flex j-content-center a-i-center direction-column empty-cart-info" }
const _hoisted_10 = { class: "text-raleway-20 mb-2 mt-2" }

import CartDeliveryComponent from "./cartDelivery/cartDeliveryComponent.vue";
import CartResultComponents from "./cartResult/cartResultComponent.vue";
import CartSortComponents from "./cartSort/cartSortComponent.vue";
import CartOrderComponent from "./cartOrder/cartOrder.vue";
import { SeoDescription, SeoTitle } from "@/utils/seo/seo";
import { computed, onBeforeMount, ref, watch } from "vue";
import { ICartCars } from "@/store/modules/Cart/type";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartView',
  setup(__props) {

const store = useStore();

const cart = ref(computed<ICartCars[]>(() => store.getters.getCartAll));

watch(
  () => store.getters.getSelectedCurrency,
  () => {
    const token = ref(computed<string>(() => store.getters.accessTokenGet));
    if (!token.value) return;
    store.dispatch("changeSortCart", "full_name");
  }
);

onBeforeMount(() => {
  const token = ref(computed<string>(() => store.getters.accessTokenGet));
  const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
  if (!token.value) store.commit("updateCartInNoAuthUser");

  switch (uiLang.value.toUpperCase()) {
    case "SWEDISH":
      SeoTitle("Tyre point: Vagn");
      SeoDescription(
        "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
      );
      break;
    case "FINLAND":
      SeoTitle("Tyre point: Kärry");
      SeoDescription(
        "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
      );
      break;
    default:
      SeoTitle("Tyre point: Cart");
      SeoDescription(
        "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
      );
      break;
  }
});

const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
watch(
  () => uiLang.value,
  () => {
    switch (uiLang.value.toUpperCase()) {
      case "SWEDISH":
        SeoTitle("Tyre point: Vagn");
        SeoDescription(
          "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
        );
        break;
      case "FINLAND":
        SeoTitle("Tyre point: Kärry");
        SeoDescription(
          "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
        );
        break;
      default:
        SeoTitle("Tyre point: Cart");
        SeoDescription(
          "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
        );
        break;
    }
  },
  {
    deep: true,
  }
);

watch(
  () => store.getters.getSelectedCurrency,
  () => {
    store.dispatch("getShoppingCart");
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$tc("cart")), 1),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "btn btn-default-inactive text-decoration-none text-center new-orders",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
          _ctx.$router.options.history.state.back === '/new_orders/truck' ||
          _ctx.$router.options.history.state.back === '/new_orders/cars'
            ? _ctx.$router.go(-1)
            : _ctx.$router.push({ path: '/new_orders/truck' })
        ), ["stop"]))
        }, _toDisplayString(_ctx.$tc("back_to_shopping")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: "btn btn-default-sm text-center clear capitalize",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(store).commit('dropAllCart')), ["stop"]))
        }, _toDisplayString(_ctx.$tc("clear")), 1)
      ])
    ], 512), [
      [_vShow, cart.value.length > 0]
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createVNode(CartSortComponents),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cart.value, (data, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 
          data.id +
          data.amount +
          (data?.local_price || data?.price || data?.fuel_consumption)
        ,
            class: _normalizeClass(["cart-result-cart_product", {
          'text-cart-result-cart_product-top-radius':
            cart.value[i]?.stock_name !== cart.value[i - 1]?.stock_name,
          'text-cart-result-cart_product-bottom-radius':
            cart.value[i]?.stock_name !== cart.value[i + 1]?.stock_name,
        }])
          }, [
            (cart.value[i]?.stock_name !== cart.value[i - 1]?.stock_name)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(data?.stock_name +
            "(" +
            _ctx.$t("Delivery") +
            data?.delivery_time +
            _ctx.$t("days") +
            ")"), 1))
              : _createCommentVNode("", true),
            _createVNode(CartResultComponents, { data: data }, null, 8, ["data"])
          ], 2))
        }), 128))
      ], 512), [
        [_vShow, cart.value.length > 0]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("Your Cart is empty")), 1),
          _createVNode(_component_router_link, {
            class: "btn btn-default-inactive text-decoration-none text-center new-orders bg-red100",
            to: { name: 'new_orders' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tc("back_to_shopping")), 1)
            ]),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, cart.value.length <= 0]
      ]),
      _createVNode(CartDeliveryComponent, {
        class: _normalizeClass('display-none-media-1200')
      }),
      _createVNode(CartOrderComponent)
    ])
  ], 64))
}
}

})